<template>
  <Link :href="event.href" class="hover:brightness-105" :title="event.title">
    <div class="m-0.5 rounded-md p-0.5" :class="event.color">
      <ParagraphText size="text-xs" class="break-words"
        ><HeroiconContainer
          v-if="event.icon"
          size="sm"
          class="sm:mr-1 inline"
          :icon="event.icon"
        /><SpanText font="font-semibold">{{ props.event.time }}</SpanText>
        {{ props.event.name }}
        <span
          v-for="(chip, index) in props.event.chips"
          :key="index"
          class="ml-0.5 inline-block whitespace-nowrap rounded px-1 align-baseline text-xs font-semibold leading-4"
          :class="[
            chip.classes,
            chip.pilot && canDrag && 'cursor-grab select-none',
          ]"
          :title="chip.title"
          :draggable="!!(chip.pilot && canDrag)"
          @dragstart="
            chip.pilot &&
              crewDrag.startDrag(chip.pilot, props.event.leg, $event)
          "
          @dragend="crewDrag && crewDrag.endDrag()"
          >{{ chip.text }}</span
        >
      </ParagraphText>

      <!-- While a pilot is being dragged, a flight that can take them grows PIC and SIC targets -->
      <div v-if="showDropZones" class="mt-0.5 flex gap-0.5">
        <span
          v-for="role in roles"
          :key="role"
          class="flex-1 rounded border border-dashed px-1 text-center text-xs font-semibold leading-5"
          :class="zoneClasses(role)"
          @dragover.prevent="
            crewDrag.slotAccepts(props.event.leg, role) &&
              crewDrag.allowMove($event)
          "
          @dragenter.prevent="
            crewDrag.slotAccepts(props.event.leg, role) &&
              crewDrag.enter(zoneKey(role))
          "
          @dragleave="crewDrag.leave(zoneKey(role))"
          @drop.prevent="crewDrag.dropOnSlot(props.event.leg, role)"
          >{{ role.toUpperCase() }}</span
        >
      </div>
    </div>
  </Link>
</template>

<script setup>
import { Link } from '@inertiajs/inertia-vue3'
import ParagraphText from '@/Common/Text/ParagraphText.vue'
import SpanText from '@/Common/Text/SpanText.vue'
import HeroiconContainer from '@/Common/Elements/HeroiconContainer.vue'
import { computed, inject } from 'vue'

const props = defineProps({
  event: Object,
})

const roles = ['pic', 'sic']

// Provided by the calendar page; absent anywhere the event has no crew slots
const crewDrag = inject('crewDrag', null)

const canDrag = computed(
  () => !!crewDrag && !!props.event.leg && props.event.canManageCrew
)

const showDropZones = computed(
  () =>
    !!crewDrag?.drag.value &&
    !!props.event.leg &&
    roles.some((role) => crewDrag.slotAccepts(props.event.leg, role))
)

function zoneKey(role) {
  return `${props.event.leg.id}-${role}`
}

function zoneClasses(role) {
  if (!crewDrag.slotAccepts(props.event.leg, role))
    return 'border-gray-400 text-gray-400 opacity-60'

  if (crewDrag.isOver(zoneKey(role)))
    return 'border-indigo-500 bg-indigo-100 text-indigo-900 dark:bg-indigo-800 dark:text-white'

  return 'border-gray-500 text-gray-700 dark:border-gray-300 dark:text-gray-100'
}
</script>
